module.exports = __webpack_public_path__ + "img/unordered-list.19a89f83.svg";